export class PhoneNumbers {
  static readonly HelixLitePhone: PhoneNumbers = {
    company: '+7 (800) 700 55 65',
    federal: null,
  };

  constructor(public company: string | null, public federal: string | null) {}
}
